<template>
    <div id="event-group">
        <div class="row topactionform smallmargin">
            <div class="col-xs-4"><div class="smalltitle">Event</div></div>

            <div class="col-xs-8">
                <form class="onelineform flowsearch">
                    <input type="text" v-model="key_search" placeholder="Enter new code"
                           class="keyinput" style="width: 50% !important;">
                    <date-picker v-model="postEventDate"
                                 format="MM/DD/YYYY"
                                 :clearable="true"
                                 @change="loadData"
                                 :append-to-body=true
                                 :custom-button=true
                                 style="float: none !important;"
                    >
                    </date-picker>
                    <date-picker v-model="endEventDate"
                                 format="MM/DD/YYYY"
                                 :clearable="true"
                                 @change="loadData"
                                 :append-to-body=true
                                 :custom-button=true
                                 style="float: none !important;"
                    >
                    </date-picker>
                    <button style="width: 15%" class="submit btn light" @click.prevent="loadData"><i
                            class="fa fa-search"></i></button>
                </form>
            </div>
        </div>

        <ul class="itemlisttable flowlisttype messageflow">
            <li class="itemlisthead">
                <div style="width: 60% !important;">Title</div>
                <div style="width: 10% !important;">Start Time</div>
                <div style="width: 10% !important;">End Time</div>
                <div style="width: 10% !important;">Post date</div>
                <div style="width: 10% !important;">Group</div>
            </li>
            <li v-if="isLoading" style="text-align: center; color: #d9df20; font-size: 16pt">
                <i class="fas fa-spinner fa-spin"></i>
            </li>
            <li v-if="!isLoading && dataEvents.length === 0" style="text-align: center; font-size: 16pt">No records
                found
            </li>
            <li v-if="!isLoading" v-for="(event, index) in dataEvents">
                <div style="width: 60% !important;">{{ event.title }}</div>
                <div style="width: 10% !important;">{{ formatFullTime(event.start_time) }}</div>
                <div style="width: 10% !important;">{{ formatFullTime(event.end_time) }}</div>
                <div style="width: 10% !important;">{{ formatFullTime(event.post_date_event) }}</div>
                <div style="width: 10% !important;">{{ event.fullName }}</div>
            </li>
        </ul>
        <br/>
        <pagination :currentPage="paginate.page" :perPage="paginate.perPage" @updatePerPage="updatePerPage"
                    :totalPages="paginate.totalPages" :total="paginate.total"></pagination>
    </div>
</template>

<script>
import axios from '../../client'
import Common from '../mixins/Common.vue'
import Pagination from '../../global/Pagination.vue'
import DatePicker from '../../global/datepicker/DatePickerCustom.vue'
import moment from 'moment'

export default {
  name: 'event-group',
  components: { Pagination, DatePicker },
  mixins: [Common],
  data () {
    return {
      key_search: '',
      isLoading: false,
      dataEvents: [],
      paginate: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      },
      isGeneratingCode: false,
      postEventDate: '',
      endEventDate: ''
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      if (!this.isLoading) {
        let params = {
          page: this.paginate.page,
          perPage: this.paginate.perPage,
          key: this.key_search,
          post_event_date: this.postEventDate ? moment(this.postEventDate).format('MM/DD/YYYY') : '',
          end_event_date: this.endEventDate ? moment(this.endEventDate).format('MM/DD/YYYY') : ''
        }
        this.isLoading = true
        axios.get(`events/get-list`, { params: params }).then(response => {
          this.isLoading = false
          if (response.data.s === 200) {
            this.dataEvents = response.data.data.events
            this.paginate.total = response.data.data.total
            this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
          } else {
            this.dataEvents = []
            this.alertError(response.data.msg)
          }
        }).catch(e => {
          this.isLoading = false
          this.alertError('Server error when load data. Press F5 to refresh browser')
        })
      }
    },
    updatePerPage (data) {
      this.paginate.perPage = data.perPage
      this.paginate.page = data.currentPage
      this.loadData()
    }
  }
}
</script>

<style>
    #event-group .mx-datepicker {
        width: 17%;
    }

    #event-group .mx-input {
        height: 40px;
    }
</style>
